define(()=> {

    return function (stepOrJunction) {
        let _data;

        /**
         * Associate a object for holding various properties with a step or junction
         *
         * @params {Object|Function} data = If no object is provided the default behavior is to return an empty object.
         *
         *
         */
        return function (data) {
            if (arguments.length === 0) {
                return _data || {};
            }
            _data = data;

            return stepOrJunction;
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/flow/build/Data.js